import Navbar from "../../Components/Navbar/navbar.component";

const Home = () => {
  return <Navbar displayText="Star Wars Explorer" />;  
};

export default Home;